<template>
    <div class="answers-list answers-list-mobile">
        <div class="col-info">
            <div class="answer-list-items" id="accordion" aria-multiselectable="true">
                <div class="answers-item-mobile" v-for="(item, indexMain) in listData.list">
                    <strong>{{ item.category }}</strong>
                    <div class="panel" v-for="(panel, index) in item.q_answers" :key="index">
                        <div class="panel-title">
                            <a :href="'#collapsePanelItem' + indexMain + index" class="panel-link" data-parent="#accordion" data-toggle="collapse" :aria-expanded="false">
                                <span>{{panel.q_name}}</span>
                                <div class="btn-press">
                                    <span class="plus">+</span>
                                    <span class="minus">-</span>
                                </div>
                            </a>
                        </div>
                        <div :id="'collapsePanelItem' + indexMain + index" class="panel-collapse collapse">
                            <div class="items-list">
                                <div class="item"><div class="desc-html" v-html="panel.q_desc"></div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    // import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'answers-list',
        props: ['listData'],
        components: {
            // svgIcon,
        },
        data () {
            return {
                questListActive: null,
                questListActiveLink: null,
            }
        },
        computed: mapGetters({
            questionsPage: 'loadQuestionsPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/answers-page/answers-list.scss';
    @import '@/styles/components/answers-page/respond/answers-list-respond.scss';
</style>